



























































































































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import {
  BoxIcon,
  HomeIcon,
  LockIcon,
  TagIcon,
  TargetIcon,
  UserIcon,
  UsersIcon,
  CpuIcon,
} from 'vue-feather-icons';
import { UserStatus } from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import ChangePasswordSettings from '@/views/pages/settings/user/ChangePasswordSettings.vue';
import AccountSettings from '@/views/pages/settings/user/AccountSettings.vue';
import AgencyInfoSettings from '@/views/pages/settings/agency/AgencyInfoSettings.vue';
import AgencyUsersSettings from '@/views/pages/settings/agency/AgencyUsersSettings.vue';
import AgencyProductsSettings from '@/views/pages/settings/agency/AgencyProductsSettings.vue';
import AgencyGoalsSettings from '@/views/pages/settings/agency/AgencyGoalsSettings.vue';
import KbvGoalsSettings from '@/views/pages/settings/user/KbvGoalsSettings.vue';
import AgencyTagsSettings from '@/views/pages/settings/agency/AgencyTagsSettings.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import IntegrationsSettings from '@/views/pages/settings/agency/IntegrationsSettings.vue';

@Component({
  name: 'settings',
  components: {
    AccountSettings,
    ChangePasswordSettings,
    UserIcon,
    UsersIcon,
    BoxIcon,
    HomeIcon,
    LockIcon,
    TargetIcon,
    TagIcon,
    AgencyInfoSettings,
    AgencyUsersSettings,
    AgencyProductsSettings,
    AgencyGoalsSettings,
    KbvGoalsSettings,
    AgencyTagsSettings,
    CpuIcon,
    IntegrationsSettings,
  },
})
class Settings extends mixins(BaseMixin, PermissionMixin) {
  availableUserStatus: UserStatus[] = [UserStatus.ACTIVE, UserStatus.DELETED];
}

export default Settings;
